var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaretRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.05434 0.952146C0.994167 1.01207 0.946425 1.08329 0.913848 1.16172C0.881271 1.24014 0.864502 1.32423 0.864502 1.40915C0.864502 1.49407 0.881271 1.57815 0.913848 1.65658C0.946425 1.735 0.994167 1.80622 1.05434 1.86615L7.70534 8.51615L1.05434 15.1691C0.948109 15.2927 0.892486 15.4518 0.898611 15.6146C0.904736 15.7774 0.972156 15.9319 1.08736 16.0471C1.20257 16.1623 1.35706 16.2297 1.51987 16.2359C1.68268 16.242 1.8418 16.1864 1.96534 16.0801L9.07534 8.96915C9.13539 8.90915 9.18302 8.83791 9.21552 8.7595C9.24802 8.68108 9.26475 8.59703 9.26475 8.51215C9.26475 8.42726 9.24802 8.34321 9.21552 8.2648C9.18302 8.18638 9.13539 8.11514 9.07534 8.05515L1.96534 0.952146C1.84442 0.831541 1.68061 0.763813 1.50984 0.763813C1.33906 0.763813 1.17525 0.831541 1.05434 0.952146Z",
    fill: "#7257F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRight);
export default __webpack_public_path__ + "static/media/CaretRight.5b7a5a1b8bb4088602e76a3e6be3c09b.svg";
export { ForwardRef as ReactComponent };